import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid'

import { toTimezone } from '@rdm/common'

import { Tooltip } from '../../Tooltip'

export const renderTimezoneCell = (params: GridRenderCellParams) => {
  const text = params.value ? toTimezone(params.value) : '-'

  return (
    <Tooltip title={text} placement="right">
      <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</Box>
    </Tooltip>
  )
}
